export default __webpack_public_path__ + "static/media/Group 3453@2x.9165a52c.png";